import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { getCookie } from '../../../utils/cookies';

interface FieldArgs {
  defaultValue?: null | string;
  inputName?: null | string;
}

interface UseSetInitialValueArgs {
  field: FieldArgs;
  fieldValue: {
    value: null | string | undefined;
  } | null | undefined;
}

export const useSetInitialValue = (
  args: UseSetInitialValueArgs,
  callback: (resolvedValue: string) => void,
) => {
  const router = useRouter();

  const {
    field: {
      defaultValue,
      inputName,
    },
    fieldValue,
  } = args;

  useEffect(() => {
    if (!fieldValue) {
      return;
    }

    const getResolvedValue = () => {
      if (defaultValue) {
        return defaultValue;
      }

      if (!inputName) {
        return null;
      }

      const queryParamValue = router.query[inputName];
      if (queryParamValue) {
        return Array.isArray(queryParamValue) ? queryParamValue.join(',') : queryParamValue;
      }

      return getCookie(inputName);
    };

    const resolvedValue = getResolvedValue();
    if (resolvedValue && fieldValue.value !== resolvedValue) {
      callback(resolvedValue);
    }
  }, [
    callback,
    defaultValue,
    fieldValue,
    inputName,
    router.query,
  ]);
};
